export default {
  meta: {
    title: '企业账号管理',
  },
};
